import React from "react";
import CheerItem, { CheerData } from "./CheerItem";
import style from "./TopCheerList.module.scss";

interface TopCheerListProps {
  data: CheerData[];
}

const TopCheerList: React.FC<TopCheerListProps> = ({ data }) => {
  return (
    <div className={style.topCheerList}>
      {data.map((item, id) => {
        return (
          <CheerItem
            key={id}
            className={style.topCheerList__item}
            titleClassName={style.topCheerList__title}
            img={item.img}
            title={item.title}
            subtitle={item.subtitle}
            amount={item.amount}
            isTopCheersType={true}
          />
        );
      })}
    </div>
  );
};

export default TopCheerList;
